import { render } from "./Marquee.vue?vue&type=template&id=348df0b8&scoped=true"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=348df0b8&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348df0b8"]])

export default __exports__